import * as Yup from 'yup';

import * as validation from '../core/utils/validation';

export const signInValidationSchema = Yup.object().shape({
  username: Yup.string()
    .required('Введите корректный логин'),
  password: Yup.string()
    .required('Введите корректный пароль'),
});

export const signUpValidationSchema = Yup.object().shape({
  password: validation.password(true, 'Для завершения регистрации введите пароль'),
  passwordConfirm: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Пароли не совпадают')
    .required('Повторите пароль'),
});

export const resetPasswordStartValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Некорректный email')
    .required('Проверьте правильность введенного email'),
});

export const resetPasswordEndValidationSchema = Yup.object().shape({
  password: validation.password(true, 'Для смены пароля введите новый пароль'),
  passwordConfirm: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Пароли не совпадают')
    .required('Повторите пароль'),
});
